import { AsyncData } from '../types/async-data.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initialValue = <R, E = any>(): AsyncData<R, E> => ({
  pending: true,
  value: null,
  error: null,
});
